import { createBrowserHistory, createHashHistory } from 'history'
import iconFile from './images/icon_file.jpg'
import { generateRouteAndMenu, IRoute, routeNames } from './const'
import BasicLayout from '~/layouts/basicLayout'
import MMPNOMatch from '~/pages/404'
import MMPNoAuth from '~/pages/403'

import generate from './modules/generates'
import _example from './modules/_example'
import departmentManagement from './modules/departmentManagement'
import basicSetting from './modules/basicSetting'
import categoryStorage from './modules/categoryStorage'
import decorationSetting from './modules/decorationSetting'
import taskActivityManagement from './modules/taskActivityManagement'
import pointsMallManagement from './modules/pointsMallManagement'
import customerServiceManagement from './modules/customerServiceManagement'
import circleManagement from './modules/circleManagement'
import Login from '../pages/login'
import { routeType } from '~/config'
import homeManagement from './modules/homeManagement'
import productCategory from './modules/productCategory'
import sensitiveKeys from './modules/sensitiveKeys'
import rewardSetting from './modules/rewardSetting'
import lotterySetting from './modules/lotterySetting'

import operatingCopywriter from './modules/operatingCopywriter'
import tagsManagement from './modules/tagsManagement'
import userManagement from './modules/userManagement'
import orderCenterOrderList from './modules/orderCenterOrderList'

import materialManage from './modules/materialManage'
import vestManage from './modules/vestManage'
import messageManage from './modules/messageManage'
import giftCardManagement from './modules/giftCardManagement'
import teamManagement from './modules/teamManagement'
import {
  AppstoreOutlined,
  BgColorsOutlined,
  ClusterOutlined,
  FundOutlined,
  SettingOutlined,
  TableOutlined,
  ShoppingCartOutlined,
  CustomerServiceFilled,
  TrophyOutlined,
  CommentOutlined,
  ShoppingOutlined,
  TeamOutlined,
  MessageOutlined,
  SkinOutlined,
  ShopOutlined,
  TagsOutlined,
  UserOutlined,
  ScheduleOutlined,
  AccountBookOutlined,
  ProfileOutlined,
  WarningOutlined,
  PictureOutlined
} from '@ant-design/icons'
export const history = routeType === 'hash' ? createHashHistory() : createBrowserHistory()

export const routers: IRoute[] = [
  { path: routeNames.login, component: Login, meta: { title: '登录', sync: true, noLogin: true } },
  {
    path: '/',
    layout: BasicLayout,
    redirect: true,
    children: [
      { name: '广告管理', icon: PictureOutlined, children: homeManagement },
      { name: '平台商品库', icon: ProfileOutlined, children: productCategory },
      { name: '敏感词库', icon: WarningOutlined, children: sensitiveKeys },
      { name: '悬赏帖时间设置', icon: AccountBookOutlined, children: rewardSetting },
      { name: '运营文案管理', icon: ScheduleOutlined, children: operatingCopywriter },
      { name: '用户管理', icon: UserOutlined, children: userManagement },
      { name: '标签管理', icon: TagsOutlined, children: tagsManagement },
      { name: '素材库管理', icon: ShopOutlined, children: materialManage },
      { name: '马甲库管理', icon: SkinOutlined, children: vestManage },
      { name: '留言讨论管理', icon: MessageOutlined, children: messageManage },

      // { name: '自动表格', icon: TableOutlined, iconImg: iconFile, children: generate },
      // { name: '模板', icon: FundOutlined, children: _example },
      // { name: '基础设置', icon: SettingOutlined, children: basicSetting },
      // { name: '类目管理', icon: ClusterOutlined, children: categoryStorage },
      // { name: '装修设置', icon: BgColorsOutlined, children: decorationSetting },
      { name: '圈子管理', icon: CommentOutlined, children: circleManagement },
      { name: '任务活动管理', icon: TrophyOutlined, children: taskActivityManagement },
      { name: '积分商城', icon: ShoppingCartOutlined, children: pointsMallManagement },
      { name: '礼品卡', icon: ShoppingOutlined, children: giftCardManagement },
      { name: '中奖设置', icon: BgColorsOutlined, children: lotterySetting },
      { name: '战队管理', icon: TeamOutlined, children: teamManagement },
      { name: '客户服务', icon: CustomerServiceFilled, children: customerServiceManagement },
      { name: '权限管理', icon: AppstoreOutlined, children: departmentManagement },
      { name: '订单中心', icon: AppstoreOutlined, children: orderCenterOrderList },
      { path: routeNames[403], component: MMPNoAuth, meta: { title: '没有权限', sync: true, noLogin: true } },
      { path: '*', component: MMPNOMatch, meta: { sync: true, noLogin: true } }
    ]
  }
]

const { routes } = generateRouteAndMenu(routers)

export function getMenus() {
  return generateRouteAndMenu(routers).menus
}

export { routes }
